import {
  client as elevioClient,
} from 'elevio';

export const setUser = (elevioUser) => {
  elevioClient.setUser(elevioUser);
};

export const getUser = () => {
  return elevioClient.getUser();
};

export default {
  setUser,
  getUser,
};